function venueCurrency(value, currencyCode = 'USD', languageCode = 'en') {
  const formatter = new Intl.NumberFormat(languageCode, {
    style: 'currency',
    currency: currencyCode,
  })

  return formatter.format(value)
}

export default {
  venueCurrency,
}



// WEBPACK FOOTER //
// ./src/utils/currentUtils.js